module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.e2d3fd0.woff";